module.exports = __webpack_public_path__ + "static/img/btn2.91bc7aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn2.png
// module id = AyvS
// module chunks = 1